import { FILTER_TAGS_TYPE, SIDEBAR_FILTERS_TAGS, SIDEBAR_OPTIONS } from "../storageNames";

export const getSidebarOptions = () => {
  const storageData = localStorage.getItem(SIDEBAR_OPTIONS);
  const defaultOptions = {
    collapsed: false,
    isOpen: true,
    openCollapse: false,
    openCollapseBoard: false,
    openCollapseMonitor: false,
  };
  if (!storageData) {
    localStorage.setItem(SIDEBAR_OPTIONS, JSON.stringify(defaultOptions));
    return defaultOptions;
  }

  return JSON.parse(storageData);
};

export const saveSidebarOptions = (newOptions) => {
  let sidebarOptions = getSidebarOptions();
  sidebarOptions = { ...sidebarOptions, ...newOptions };
  localStorage.setItem(SIDEBAR_OPTIONS, JSON.stringify(sidebarOptions));
};

export const sidebarFiltersTags = {
  saveSidebarFilterTags: (tags) => {
    sessionStorage.setItem(SIDEBAR_FILTERS_TAGS, JSON.stringify(tags));
  },
  getSidebarFilterTags: () => {
    const fromStorage = sessionStorage.getItem(SIDEBAR_FILTERS_TAGS);
    return fromStorage ? JSON.parse(fromStorage) : [];
  },
  saveFilterType: (filterType) => {
    sessionStorage.setItem(FILTER_TAGS_TYPE, filterType)
  },
  getFilterType: () => {
     const fromStorage = sessionStorage.getItem(FILTER_TAGS_TYPE);
     return fromStorage ? fromStorage : 'OR';
  }
};
